import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
	createStyles({
		paper: {
			padding: theme.spacing(2),
			borderRadius: "10px",
			height: theme.spacing(14),
		},
		itemRoot: {
			flexGrow: 1,
		},
		headerCardRoot: {
			flexGrow: 1,
			width: "100%",
		},
		h400: {
			height: "400px",
		},
		mb3: {
			marginBottom: theme.spacing(3),
		},
		scenarioGroupingBracket: {
			borderBottomLeftRadius: "5px",
			borderTopLeftRadius: "5px",
			borderStyle: "solid",
			borderColor: "#5e6e7d",
			borderWidth: "2px",
			borderRightStyle: "none",
			display: "flex",
			flexDirection: "column",
			width: "10px",
			height: "inherit",
			marginTop: "18px",
			marginRight: "8px",
		},
		scenarioGroupingCircle: {
			border: "0.5px solid #7ea6b4",
			borderRadius: "100%",
			marginTop: "22px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			marginRight: "12px",
			width: "24px",
			height: "24px",
		},
		chartArea: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
		},
		listContainer: {
			display: "flex",
			justifyContent: "space-evenly",
			backgroundColor: theme.palette.grey[100],
			borderRadius: "10px",
			height: "40px",
			padding: "5px",
		},
		button: {
			borderRadius: "10px",
			height: "30px",
		},
		mr1: {
			marginRight: theme.spacing(1),
		},
		footerCard: {
			height: "200px",
			overflowY: "scroll",
			"&::-webkit-scrollbar": {
				display: "none",
			},
		},
		footerCardContainer: {
			height: "250px",
		},
		overflowScroll: {
			overflowY: "scroll",
			"&::-webkit-scrollbar": {
				display: "none",
			},
		},
		mw175: {
			minWidth: "175px",
		},
		divider: {
			flexGrow: 1,
			borderTop: `3px solid ${theme.palette.grey[300]}`,
			marginLeft: theme.spacing(2),
			marginRight: theme.spacing(2),
		},
		fullWidthDivider: {
			flexGrow: 1,
			borderTop: `3px solid ${theme.palette.grey[300]}`,
		},
		dividerThin: {
			flexGrow: 1,
			borderTop: `1px solid ${theme.palette.grey[300]}`,
		},
		noTextTransform: {
			textTransform: "none",
		},
		mr4: {
			marginRight: theme.spacing(4),
		},
		mt5: {
			marginTop: theme.spacing(2),
		},
		w600: {
			fontWeight: 600,
		},
		fs18: {
			fontSize: "18px",
		},
		tableRoot: {
			width: "100%",
			padding: theme.spacing(4),
		},
		narrowTable: {
			width: "70%",
		},
		scopeTable: {
			width: "100%",
			borderCollapse: "collapse",
		},
		scopeTableRowAlternate: {
			backgroundColor: "#f5f8f9",
			height: "48px",
			width: "100%",
		},
		scopeTableRow: {
			height: "48px",
			backgroundColor: "#ffffff",
			width: "100%",
		},
		alternativesTableRow: {
			height: "28px",
			backgroundColor: "#ffffff",
			width: "100%",
		},
		scopeHeaderCell: {
			width: "24%",
			padding: "16px 0px 16px 24px",
		},
		scopeCell: {
			border: "none",
			whiteSpace: "pre-wrap",
			verticalAlign: "middle",
			padding: "12px 24px 12px 24px",
		},
		vaTop: {
			verticalAlign: "top",
		},
		vaCenter: {
			verticalAlign: "center",
		},
		stickyCard: {
			position: "sticky",
			top: "7.5rem",
		},
		w100: {
			width: "100%",
		},
		mV1: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
		p2: {
			padding: theme.spacing(2),
		},
		br10: {
			borderRadius: "10px",
		},
		optionLabel: {
			textTransform: "uppercase",
			fontWeight: "bold",
		},
		optionDescription: {
			marginTop: theme.spacing(1),
			color: "#A7B1B9",
		},
		menuItemContent: {
			paddingTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
			maxWidth: "500px",
			whiteSpace: "normal",
			borderTop: "2px solid #EBEBEB",
		},
		firstMenuItemContent: {
			borderTop: "none",
		},
		linkBold: {
			fontWeight: 600,
			color: "#367bf5",
			fontSize: "16px",
			cursor: "pointer",
		},
		propsCard: {
			padding: theme.spacing(2),
			marginTop: theme.spacing(2),
		},
		mr7: {
			height: "130px",
			width: "49%",
		},
		linkDisabled: {
			fontWeight: 600,
			color: "#808080",
			fontSize: "16px",
			cursor: "pointer",
		},
	})
);
